import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environment/environment';
import { M4UAngularModule } from './_modules/m4uangular.module';
import themes from 'devextreme/ui/themes';
if (environment.production) {
  enableProdMode();
}

//Dispatch 'applicationStarted' event
//Syntax was adapted to work in the IE browser
var event = document.createEvent('Event');
event.initEvent('applicationStarted', true, true);
document.dispatchEvent(event);

themes.initialized(() => {
    platformBrowserDynamic().bootstrapModule(M4UAngularModule)
        .then(() => {
            //Dispatch 'applicationLoaded' event
            //Syntax was adapted to work in the IE browser
            var event = document.createEvent('Event');
            event.initEvent('applicationLoaded', true, true);
            document.dispatchEvent(event);
        })
        .catch(err => console.error(err));
});